import { render, staticRenderFns } from "./WaybillCustomizer.vue?vue&type=template&id=12d8e098&"
import script from "./WaybillCustomizer.vue?vue&type=script&lang=js&"
export * from "./WaybillCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./WaybillCustomizer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports